import { Model } from "@tailflow/laravel-orion/lib/model";

export class Language extends Model {
    $resource(): string {
        return "language";
    }
}
